// var domain = location.hostname.split('.').shift()
var baseUrl = `https://${location.hostname}`
// var baseUrl = `https://${domain}.beebeeboard.com`

if (process.env.NODE_ENV === 'development') {
  baseUrl = 'https://test.beebeeboard.com'
}

export const BASEURL = baseUrl
export const DATAURL = 'https://data.beebeeboard.com'



// WEBPACK FOOTER //
// ./src/config.js